<div class="flex flex-col justify-center align-center">
  <div class="flex gap-4 justify-center align-center">
    <mat-icon fontIcon="gpp_maybe" class="material-symbols-outlined"></mat-icon>
    <h1>Unauthorized</h1>
  </div>
  <p>Account has not been activated. Please mark your account as active in the DB to resolve.</p>
</div>
